import { AxiosError } from 'axios';
import { useTranslation } from 'next-i18next';

import { logger } from '@zep/core-logger';

import { alertDialog } from '@/ui_v3';

export const useAiGenerateSimilarQuizErrorAlert = () => {
  const { t } = useTranslation(['build', 'common']);
  return (error: unknown, errorEventName: string) => {
    let filteredError: unknown;
    if (error instanceof AxiosError) {
      // 메시지와 데이터만 필터링
      filteredError = {
        message: error.message,
        data: error.config?.data,
      };
    } else {
      filteredError = error;
    }
    logger.track(errorEventName, {
      error: filteredError,
    });
    alertDialog.open({
      header: {
        title: t('build:similarQuiz.error.title'),
      },
      body: t('build:similarQuiz.error.description'),
      confirmIntent: 'destructive',
    });
  };
};
